/**
 * PMS-specific UI (PMS category column, room usage analytics) is shown only
 * when the hotel has PMS settings with `enabled === true`. `hotel.pms` is not
 * usable here: it always carries a default provider. Missing settings (404 or
 * still loading) count as "no PMS".
 */
export const isPmsEnabled = (
  settings: { enabled?: boolean } | null | undefined,
): boolean => settings?.enabled === true;

/**
 * Hide PMS UI only when the absence of PMS is confirmed: the settings request
 * succeeded and returned no settings or disabled ones. While loading or after
 * an error the UI stays as before.
 */
export const shouldShowPmsColumns = ({
  data,
  isSuccess,
  isError,
}: {
  data: { enabled?: boolean } | null | undefined;
  isSuccess: boolean;
  isError: boolean;
}): boolean => {
  if (isError || !isSuccess) return true;
  return isPmsEnabled(data);
};

/**
 * The PMS indicator on the Dashboard is shown only for a hotel with an
 * enabled PMS integration (and platform access to PMS). Unconfigured hotels
 * (e.g. Rapid plan) must not see a red provider badge taken from the default
 * `hotel.pms`.
 */
export const shouldShowPmsIndicator = (
  hasPmsAccess: boolean,
  settings: { enabled?: boolean } | null | undefined,
): boolean => hasPmsAccess && isPmsEnabled(settings);
